import { UID } from 'shared/api/query/constants';
import { personalAccessToken as personalAccessTokenConfig } from 'shared/api/query/configs.json';

export const personalAccessTokenEdges = [
  { attr: UID },
  { attr: personalAccessTokenConfig.edges.name },
  { attr: personalAccessTokenConfig.edges.expiresAt },
  { attr: personalAccessTokenConfig.edges.lastUsedAt, default: null },
  { attr: personalAccessTokenConfig.edges.rotatedAt },
];
